import { render } from "./pop-up.vue?vue&type=template&id=00eb01b2&scoped=true"
import script from "./pop-up.vue?vue&type=script&lang=js"
export * from "./pop-up.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-00eb01b2"

export default script